/**
 * 語言對應工具函數
 * 將瀏覽器語言對應到系統支援的語言
 */

/**
 * 取得系統支援的語言
 * @param {string} browserLang - 瀏覽器語言代碼 (例如: 'zh', 'zh-CN', 'en', 'en-US')
 * @returns {string} 系統支援的語言代碼
 */
export const getSupportedLanguage = (browserLang = navigator.language) => {
    // 支援的語言列表
    const supportedLanguages = ['zh-TW', 'en-US', 'vi'];
    
    // 完全匹配
    if (supportedLanguages.includes(browserLang)) {
        return browserLang;
    }
    
//    // 部分匹配（例如 zh-CN, zh-HK 對應到 zh-TW）
//    if (browserLang.startsWith('zh')) {
//        return 'zh-TW';
//    }
//
//    if (browserLang.startsWith('en')) {
//        return 'en-US';
//    }
//
//    if (browserLang.startsWith('vi')) {
//        return 'vi';
//    }
    
    // 預設回傳英文
    return 'en-US';
};

/**
 * 語言代碼常數
 */
export const SUPPORTED_LANGUAGES = {
    ZH_TW: 'zh-TW',
    EN_US: 'en-US',
    VI: 'vi'
};

/**
 * 語言顯示名稱對應
 */
export const LANGUAGE_NAMES = {
    'zh-TW': '繁體中文',
    'en-US': 'English',
    'vi': 'Tiếng Việt'
};
